import { createContext } from 'react';

/** Переход на раздел панели (индекс и подраздел отчётов) - передаётся из AdminPanel в виджеты «Главной» */
export type HomeNavigate = (index: number, module?: string) => void;

export const HomeNavigationContext = createContext<HomeNavigate | null>(null);
